<section class="terms-of-use">

  <header>
    <h1>Terms of Use</h1>

    <address>
      <strong>iFlyFinance, Inc.</strong><br />
      1881 California Ave, Suite 101<br />
      Corona, CA 92881
    </address>

    <p>
      <strong>Effective Date:</strong> January 6, 2026
    </p>
  </header>

  <p>
    These Terms of Use (<strong>"Terms"</strong>) govern your access to and use
    of the website located at
    <a href="https://www.iflyfinance.com" target="_blank" rel="noopener noreferrer">
      www.iFlyFinance.com
    </a>
    (the <strong>"Website"</strong>) and any related online services, portals,
    applications, or electronic communications provided by iFlyFinance Inc.
    (<strong>"iFlyFinance," "Company," "we," "us," or "our"</strong>).
  </p>

  <p>
    By accessing, browsing, or using the Website, you acknowledge that you have
    read, understand, and agree to be bound by these Terms and by our Privacy
    Policy. If you do not agree to these Terms, you may not access or use the
    Website.
  </p>

  <h2>1. About iFlyFinance</h2>
  <p>
    iFlyFinance Inc. is a premium finance company that provides insurance premium
    financing services to eligible customers, subject to applicable laws,
    regulations, and licensing requirements. The Website is provided for
    informational purposes only and does not constitute an offer to lend or a
    commitment to provide financing.
  </p>

  <h2>2. Eligibility and Permitted Use</h2>
  <p>
    The Website is intended for individuals who are at least 18 years of age and
    for businesses acting through authorized representatives. By using the
    Website, you represent and warrant that:
  </p>
  <ul>
    <li>You are at least 18 years old</li>
    <li>You have the legal authority to enter into binding agreements</li>
    <li>All information you provide is accurate, complete, and current</li>
    <li>You will use the Website only for lawful purposes</li>
  </ul>

  <h2>3. No Offer or Advice</h2>
  <p>
    Information on the Website is provided for general informational purposes
    only and does not constitute a binding offer to provide financing, financial
    or legal advice, or a guarantee of loan approval or specific loan terms.
    All financing decisions are subject to underwriting, documentation, and
    regulatory requirements.
  </p>

  <h2>4. Applications and Electronic Transactions</h2>
  <p>
    Certain Website features may allow you to submit applications or related
    information electronically. By submitting information, you:
  </p>
  <ul>
    <li>Authorize iFlyFinance to review and evaluate your submission</li>
    <li>Consent to electronic records, signatures, and communications</li>
    <li>Acknowledge that electronic agreements are legally binding</li>
  </ul>
  <p>
    Submission of information does not obligate iFlyFinance to extend credit or
    provide services.
  </p>

  <h2>5. User Responsibilities</h2>
  <p>You are responsible for:</p>
  <ul>
    <li>Maintaining the confidentiality of login credentials</li>
    <li>Restricting access to your devices and accounts</li>
    <li>All activity conducted using your credentials</li>
  </ul>

  <p>You agree not to:</p>
  <ul>
    <li>Use the Website for fraudulent or misleading purposes</li>
    <li>Attempt to gain unauthorized access to systems or data</li>
    <li>Interfere with Website security or operations</li>
    <li>Upload or transmit malicious or harmful code</li>
  </ul>

  <h2>6. Intellectual Property</h2>
  <p>
    All Website content, including text, graphics, logos, trademarks, software,
    and design elements, is owned by iFlyFinance or its licensors and is protected
    by intellectual property laws.
  </p>
  <p>
    You may use Website content solely for personal or internal business purposes
    related to evaluating iFlyFinance services. Unauthorized copying,
    modification, or distribution is prohibited.
  </p>

  <h2>7. Third-Party Links and Services</h2>
  <p>
    The Website may contain links to third-party websites or services.
    iFlyFinance does not control and is not responsible for third-party content
    or practices. Accessing third-party websites is at your own risk.
  </p>

  <h2>8. Availability and Modifications</h2>
  <p>
    iFlyFinance reserves the right to modify, suspend, or discontinue any portion
    of the Website at any time without notice. We do not guarantee uninterrupted,
    error-free, or secure access.
  </p>

  <h2>9. Disclaimer of Warranties</h2>
  <p class="uppercase">
    THE WEBSITE AND ALL CONTENT ARE PROVIDED "AS IS" AND "AS AVAILABLE."
    TO THE MAXIMUM EXTENT PERMITTED BY LAW, IFLYFINANCE DISCLAIMS ALL WARRANTIES,
    EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR
    PURPOSE, AND NON-INFRINGEMENT.
  </p>

  <h2>10. Limitation of Liability</h2>
  <p class="uppercase">
    TO THE MAXIMUM EXTENT PERMITTED BY LAW, IFLYFINANCE SHALL NOT BE LIABLE FOR ANY
    INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR PUNITIVE DAMAGES.
  </p>
  <p class="uppercase">
    IFLYFINANCE’S TOTAL LIABILITY SHALL NOT EXCEED ONE HUNDRED DOLLARS ($100).
  </p>

  <h2>11. Indemnification</h2>
  <p>
    You agree to indemnify and hold harmless iFlyFinance and its officers,
    directors, employees, and agents from any claims arising from your use of
    the Website or violation of these Terms.
  </p>

  <h2>12. Privacy</h2>
  <p>
    Your use of the Website is subject to our Privacy Policy, which is
    incorporated by reference into these Terms.
  </p>

  <h2>13. Governing Law and Jurisdiction</h2>
  <p>
    These Terms are governed by the laws of the State of California. Any legal
    action arising from these Terms shall be brought exclusively in the state or
    federal courts located in California.
  </p>

  <h2>14. Severability</h2>
  <p>
    If any provision of these Terms is found to be invalid or unenforceable, the
    remaining provisions shall remain in full force and effect.
  </p>

  <h2>15. Entire Agreement</h2>
  <p>
    These Terms, together with the Privacy Policy and any other legal notices,
    constitute the entire agreement regarding use of the Website.
  </p>

  <h2>16. Contact Information</h2>
  <address>
    <strong>iFlyFinance Inc.</strong><br />
    1881 California Ave, Suite 101<br />
    Corona, CA 92881<br />
    Email:
    <a href="mailto:support@iflyfinance.com">support&#64;iflyfinance.com</a>
  </address>

</section>
